<template>
  <div class="about animated fadeIn">
    <div class="body">
      <div class="row">
          <div class="col-md-6 col-6">
             <SidebarView title="About" single="true" />
          </div>
          <div class="col-md-6 col-6 text-right">
           <router-link to="/">
            <img src="../assets/images/icon.jpg" class="myicon"/>
           </router-link>
        </div>
      </div>
      <br /><br />
      <div class="row">
        <div class="col-md-5">
          <img src="../assets/images/hello.jpg" class="profileimage" />
        </div>
        <div class="col-md-7 description">
          <h1 class="hello">Hi, I'm Adora</h1>
          <br />
          <p>My name is Nenne Adaora Nwodo, and people know me professionally as Adora Nwodo. I'm an award winning engineering leader and former VP of Engineering with 15+ years of experience building and scaling platforms, distributed systems, and AI driven services. I lead multi team organizations across multi cloud infrastructure on AWS, Azure, and GCP, spanning developer platforms, networking, Kubernetes governance, identity and access, and reliability engineering, with a consistent focus on operating mission critical systems under strict SLOs.</p>

          <p>My leadership blends deep technical expertise with organization level impact. I've built platform operating models that give product teams paved roads instead of tickets, designed event driven architectures that move data reliably at scale, and set the governance and compliance foundations that let regulated systems ship quickly without losing control. I partner closely with executives and product leaders to translate strategy into technical direction, shape long term roadmaps, and deliver measurable outcomes. My work increasingly centers on how AI changes platform engineering, from intelligent automation to AI supported developer workflows and the infrastructure that keeps probabilistic systems dependable.</p>

          <p>Beyond leading engineering orgs, I'm a multi published author of seven books on cloud, DevOps, and AI with Wiley, O'Reilly, Packt, and Kogan Page, with two more in progress. My <router-link to="/books">books</router-link> are in the libraries of Harvard, Princeton, and Drexel, and I teach technical <router-link to="/courses">courses</router-link> on LinkedIn Learning and O'Reilly. I've delivered over 200 talks worldwide on intelligent systems, developer platforms, and emerging technologies, and I publish peer reviewed research on AI infrastructure and system reliability.</p>

          <p>I founded NexaScale, a social enterprise that equips early career technologists with simulated remote work experiences, and I serve as a Founding Ambassador of the Agentic AI Foundation under the Linux Foundation. I've also contributed as an Executive in Residence and mentor in graduate and undergraduate programs. Much of this work is about the same thing my day job is about: helping people and organizations adopt AI responsibly and build secure, scalable systems on solid cloud foundations.</p>

          <p>Recognitions include Microsoft MVP (Azure), WomenTech Software Engineering Leader of the Year, the Future Africa Award for Education, and <router-link to="/awards">more</router-link>. Academically, I hold a First Class BSc in Computer Science, a Stanford LEAD diploma in Corporate Innovation, and an MSc in Computer Science with an AI specialization from Georgia Tech. I'm currently pursuing my MBA at the University of Michigan Ross School of Business.</p>

          <p>I'm passionate about scaling engineering organizations, advancing the intersection of cloud and AI, and building resilient intelligent platforms that serve users at scale.</p>

          <p>
            <a rel="noopener" target="_blank" href="https://x.com/adoranwodo">Say hi to me </a><br />
          </p>
        </div>
      </div>
      <img src="../assets/images/io.png" class="centerpattern"/>
      <div class="row">
        <div class="col-md-4 col-sm-6 service-container">
          <router-link to="/books">
            <img src="../assets/images/books-and-courses.jpg" class="service" />
            <div class="service-card card text-center">
              <h5>Books</h5> 
              <p>Read my tech books!</p>
            </div>
          </router-link>
        </div>
        <div class="col-md-4 col-sm-6 service-container">
          <router-link to="/courses">
            <img src="../assets/images/courses-front.png" class="service" />
            <div class="service-card card text-center">
              <h5>Courses</h5> 
              <p>I teach too!</p>
            </div>
          </router-link>
        </div>
        <div class="col-md-4 col-sm-6 service-container">
          <router-link to="/awards">
            <img src="../assets/images/awards-new.png" class="service" />
            <div class="service-card card text-center">
              <h5>Awards</h5> 
              <p>Recognition for my work</p>
            </div>
          </router-link>
        </div>
        <div class="col-md-4 col-sm-6 service-container">
          <router-link to="/features">
            <img src="../assets/images/news-min.jpg" class="service" />
            <div class="service-card card text-center">
              <h5>Features</h5> 
              <p>Stories in the media</p>
            </div>
          </router-link>
        </div>
        <div class="col-md-4 col-sm-6 service-container">
          <router-link to="/blog">
            <img src="../assets/images/blog-min.jpg" class="service" />
            <div class="service-card card text-center">
              <h5>Blog</h5> 
              <p>AdoraHack</p>
            </div>
          </router-link>
        </div>
        <div class="col-md-4 col-sm-6 service-container">
          <router-link to="/videos">
            <img src="../assets/images/yt-new.png" class="service" />
            <div class="service-card card text-center">
              <h5>Videos</h5> 
              <p>Adora on YouTube</p>
            </div>
          </router-link>
        </div>
        <div class="col-md-4 col-sm-6 service-container">
          <router-link to="/talks">
            <img src="../assets/images/osca.jpg" class="service" />
            <div class="service-card card text-center">
              <h5>Talks</h5> 
              <p>I speak too</p>
            </div>
          </router-link>
        </div>
        <div class="col-md-4 col-sm-6 service-container">
          <router-link to="/community">
            <img src="../assets/images/community.jpg" class="service" />
            <div class="service-card card text-center">
              <h5>Community</h5> 
              <p>Communities I help run</p>
            </div>
          </router-link>
        </div>
        <div class="col-md-4 col-sm-6 service-container">
          <router-link to="/podcasts">
            <img src="../assets/images/podcast-min.jpg" class="service" />
            <div class="service-card card text-center">
              <h5>Podcasts</h5> 
              <p>Podcasts I've been on</p>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <FooterView />
  </div>
</template>

<script>
import SidebarView from '@/components/SidebarView.vue' 
import FooterView from '@/components/FooterView.vue' 

export default {
  components: {
    SidebarView,
    FooterView
  }
}
</script>

<style scoped>
/* NEW STYLES */
.about h1.hello{
  line-height: 98%;
}
.about h5, .about p{
  color: black;
}
.about a:hover h5, .about a:hover p{
  color: #c12688;
}
.about .profileimage{
  width: 100%;
  margin-bottom: 40px;
  border-top-left-radius: 40px;
  border-bottom-right-radius: 40px;
  border: 4px dashed #c12688;
}
.about .centerpattern{
  margin-top: 60px;
  margin-bottom: 100px;
  margin-left: auto;
  margin-right: auto;
  display: block;
  width: 270px;
}
.about .linkicon{
  height: 50px;
  margin: 0 auto;
  display: block;
}
.about .card{
  border-radius: 0px;
  border-color: transparent;
  -webkit-box-shadow: 0px 0px 20px -13px rgba(0,0,0,0.7);
  -moz-box-shadow: 0px 0px 20px -13px rgba(0,0,0,0.7);
  box-shadow: 0px 0px 20px -13px rgba(0,0,0,0.7);
  background: white;
}
.about .service{
  width: 100%;
}
.about .service-card{
  padding: 10px 30px;
  width: 70%;
  background: white;
  position: relative;
  bottom: 30px;
  left: 15%;
}
.about .service-container{
  margin-bottom: 110px;
}
.about .service-container a{
  text-decoration: none !important;
}
.about .description p{
  font-size: 14px !important;
}
@media only screen and (max-width: 1180px) {
  .about .service-container p{
    font-size: 12px !important;
  }
}
@media only screen and (max-width: 930px) {
  .about .service-container p{
    font-size: 9px !important;
  }
}
@media only screen and (max-width: 750px) {
  .about .service-container p{
    font-size: 12px !important;
  }
}
.about .service-container p{
  margin-bottom: 0px;
}
.about h5{
  font-size: 15px;
}
.about p a{
    text-decoration: underline;
    color: black;
}
.about p a:hover{
    color: #c12688;
}
</style>

